import { render, staticRenderFns } from "./SimilarProductsCarousel.vue?vue&type=template&id=1d2ed9d8&scoped=true"
import script from "./SimilarProductsCarousel.vue?vue&type=script&lang=js"
export * from "./SimilarProductsCarousel.vue?vue&type=script&lang=js"
import style0 from "./SimilarProductsCarousel.vue?vue&type=style&index=0&id=1d2ed9d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2ed9d8",
  null
  
)

export default component.exports